module.exports = __webpack_public_path__ + "img/backar.9a5baab3.jpg";